import React from "react"
import { Box, Link, Text } from "@chakra-ui/react"
import { NavLink } from "react-router-dom"
import  GaraazCopyText  from "./GaraazCopyText"


function GaraazOrderNumber({ orderNo }: any) {
  const hostname = typeof window !== "undefined" ? window.location.hostname : "";
  const isUAT = hostname.includes("uat") || hostname === "localhost";

  const baseUrl = isUAT
    ? "https://uat.orca.garaaz.com" 
    : "https://orca.garaaz.com";
    
  return (
    <Box position={"relative"}>
    <Link target="_blank" as={NavLink} to={`${baseUrl}/same-part-orders?orderNo=${orderNo}`} _hover={{color:"none"}}>
      {orderNo}
    </Link>
      <Text as={"span"} position={"absolute"} mt={"5px"}>
        {" "}
        <GaraazCopyText
          text={orderNo}
          popOverMessage={"Copied!"}
        />
      </Text>
    </Box>
  )
}

export default GaraazOrderNumber